import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Slick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as styles from './styles/styles.module.scss';
import * as fontStyles from '../../../styles/fontStyles.module.scss';
import CarouselArrowNext from '../../../../assets/images/icons/carouselArrowNext.svg';
import CarouselArrowPrev from '../../../../assets/images/icons/carouselArrowPrev.svg';
import classNames from 'classnames';

const ArrowFn = (key, bg, arrowStyles) => {
  return ({ className, style, onClick }) => {
    return (
      <button
        aria-label={key}
        className={`${className} ${styles.button} ${styles[key]} lazyload ${arrowStyles[key]}`}
        data-bg={bg}
        onClick={onClick}
        style={style}
        title={key}
        type="button"
      />
    );
  };
};

const River = ({ className, title, children, useSlick, slickSettings, arrowStyles }) => {
  const [dragging, setDragging] = useState(false);

  const [PrevArrow, NextArrow] = useMemo(() => {
    return [ArrowFn('previous', CarouselArrowPrev, arrowStyles), ArrowFn('next', CarouselArrowNext, arrowStyles)];
  }, [arrowStyles]);

  let river;
  if (useSlick) {
    const handleBeforeChange = () => {
      setDragging(true);
    };

    const handleAfterChange = () => {
      setDragging(false);
    };

    // Prevent propagation of click to inner elements when dragging slick carousel
    const onClickCapture = e => {
      if (dragging) {
        e.stopPropagation();
      }
    };

    const defaultSlickSettings = {
      accessibility: true,
      afterChange: handleAfterChange,
      beforeChange: handleBeforeChange,
      className: `${className} ${styles.slickRiver}`,
      dots: false,
      infinite: false,
      initialSlide: 0,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      variableWidth: true,
      lazyLoad: true,
      ...slickSettings
    };
    slickSettings = Object.assign(defaultSlickSettings, slickSettings);

    river = (
      <Slick {...slickSettings}>
        {children.map((child, i) => (
          <div className={styles.riverItem} key={`riverItem-${i}`} onClickCapture={onClickCapture}>
            {child}
          </div>
        ))}
      </Slick>
    );
  } else {
    river = (
      <div className={classNames(className, styles.river)}>
        <div className={styles.riverTrack}>
          {children.map((child, i) => (
            <div className={styles.riverItem} key={`riverItem-${i}`}>
              {child}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {title && <h2 className={classNames(styles.title, fontStyles.title1)}>{title}</h2>}
      {river}
    </>
  );
};

River.defaultProps = {
  children: [],
  className: '',
  slickSettings: {},
  title: '',
  useSlick: false,
  arrowStyles: {
    next: '',
    previous: ''
  }
};

River.propTypes = {
  children: PropTypes.array,
  className: PropTypes.string,
  slickSettings: PropTypes.object,
  title: PropTypes.string,
  useSlick: PropTypes.bool,
  arrowStyles: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string
  })
};

export default River;
